import React, { Component, useReducer } from "react";
import { connect } from "react-redux";
import _ from "underscore";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import AppWrapper from "../Common/AppWrapper/index.jsx";
import Loading from "../Common/Misc/Loading.jsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import * as assayActions from "../../actions/assays";
import { EnhancedTableHead, styles } from "../MyAssays";
import PropTypes from "prop-types";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ResultTableRow } from "./ResultTableRow";
import TablePagination from "@material-ui/core/TablePagination";
import classNames from "classnames";
import Tooltip from "@material-ui/core/Tooltip";
import { formatDateTime, getSorting } from "../../util/format";
//import * as resultData from "../../sampleData/get_history_response.json";

const columnData = [
  {
    id: "assayName",
    numeric: false,
    label: "Assay Name",
  },
  {
    id: "targetName",
    numeric: false,
    label: "Target Name",
  },
  {
    id: "assayType",
    numeric: false,
    label: "Assay Type",
  },
  {
    id: "wetlabValidated",
    numeric: false,
    label: "Wet Lab Validated",
  },
  {
    id: "chemistry",
    numeric: false,
    label: "Chemistry",
  },
  {
    id: "dyes",
    numeric: false,
    label: "Probe Fluorophore(s)",
  },
  {
    id: "id",
    numeric: false,
    label: "ID",
  },
  {
    id: "geneId",
    numeric: false,
    label: "Gene ID",
  },
  {
    id: "geneName",
    numeric: false,
    label: "Gene Name",
  },

  {
    id: "cosmicId",
    numeric: false,
    label: "Cosmic ID",
  },
];

const initialState = {
  order: "asc",
  orderBy: "",
  page: 0,
  rowsPerPage: 5,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SORT_BY_PROPERTY":
      return {
        ...state,
        order: action.payload.order,
        orderBy: action.payload.orderBy,
      };
    case "CHANGE_PAGE":
      return {
        ...state,
        page: action.payload.page,
      };
    case "CHANGE_ROWS_PER_PAGE":
      return {
        ...state,
        rowsPerPage: action.payload.rowsPerPage,
      };
    default:
      return state;
  }
};

const ResultsTable = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { classes, data } = props;
  const { order, orderBy, rowsPerPage, page } = state;
  const searchResults = data;
  const handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (state.orderBy === property && state.order === "desc") {
      order = "asc";
    }
    dispatch({ type: "SORT_BY_PROPERTY", payload: { order, orderBy } });
  };
  const handleChangePage = (event, page) => {
    dispatch({ type: "CHANGE_PAGE", payload: { page } });
  };
  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type: "CHANGE_ROWS_PER_PAGE",
      payload: { rowsPerPage: event.target.value },
    });
  };
  return (
    <div className="assay-results search-results sub-search-results ">
      <Table className={classes.table}>
        <EnhancedTableHead
          className={classNames("search-results")}
          columnData={columnData}
          order={state.order}
          orderBy={state.orderBy}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {searchResults &&
            !_.isEmpty(searchResults) &&
            [...searchResults]
              .sort(getSorting(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <ResultTableRow
                    key={index}
                    row={row}
                    evenOddClass={index % 2 ? "even" : "odd"}
                    //assayDetail={assayDetail}
                    {...props}
                  />
                );
              })}
        </TableBody>
      </Table>
      <TablePagination
        className={classNames(
          classes.select,
          classes.menuItem,
          "table-pagination"
        )}
        component="div"
        count={searchResults.length}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5, 10, 20, 50, 75]}
        page={page}
        backIconButtonProps={{
          "aria-label": "Previous Page",
        }}
        nextIconButtonProps={{
          "aria-label": "Next Page",
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default withStyles(styles)(ResultsTable);
